import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button, NewButton, SaveButton } from "../../../../components/Buttons";

export const Party = () => {
    document.title = "Partiya";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Partiya", value: "/products/parameters/party", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Partiya</h2>
                    <p>
                        Əgər eyni məhsul müxtəlif partiyalar şəklində anbara daxil olursa, bu prosesi qeyd etmək üçün məhsulun partiyaları qeyd edilməlidir.
                        <ol>
                            <li>
                                Partiya əlavə etməyin ilk yolu <b>Ayarlar</b> səhifəsində <Button>Partiya</Button> seçimini edib, <Button>Yeni partiya</Button>
                                düyməsini sıxmaq lazımdır.
                            </li>
                            <li>
                                Açılan pəncərədə Partiya <b>adını</b> qeyd edib <SaveButton /> düyməsini sıxmaq lazımdır.
                            </li>
                        </ol>
                        <br />
                        Məhsul yaradılanda partiyalı məhsul olduğunu qeyd etmək lazımdır.
                        <ol>
                            <li>
                                <NewButton>Yeni məhsul</NewButton> düyməsini sıxın və açılan pəncərədə xanaları doldurub <b>Əlavə parametrlər</b> hissəsində
                                <b>Partiyalı məhsul</b> seçimini edin
                            </li>
                            <li>
                                <SaveButton /> düyməsini sıxın.
                            </li>
                        </ol>
                    </p>
                    <img src="/images/products/parameters/party.gif" alt="Partiya" />
                </article>
            </div>
        </div>
    );
};
